module.exports = __webpack_public_path__ + "static/img/A166.e932aae8.jpg";